<template>
  <div>
    <a-card v-if="customerStatementsList":bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <!--        筛选的条件-->
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="企业名称" style="margin-left: 45px":labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  showSearch

                  optionFilterProp="children"
                  :filterOption="filterOption"
                  v-model="queryParam.enterpriseName"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in selectCombox" :title="type.enterpriseName":key="type.enterpriseId">{{ type.enterpriseName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="账单号" style="margin-left: 60px">
                <a-input v-model.trim="queryParam.statementNo"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="账单状态" style="margin-left: 45px">
                <a-select v-model="queryParam.statementStatus" :allowClear="true">
                  <a-select-option v-for="type in statement_status" :title="type.dictLabel":key="type.dictValue">{{ type.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="收款状态" style="margin-left: 45px">
                <a-select v-model="queryParam.receiveMoneyStatus" :allowClear="true">
                  <a-select-option v-for="type in receive_money_status":title="type.dictLabel" :key="type.dictValue">{{ type.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="收款超时天数" style="margin-left: 15px">
                <a-input v-model.trim="queryParam.overDays"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户姓名" style="margin-left: 45px">
                <a-input v-model.trim="queryParam.clientName"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="客户联系方式" style="margin-left: 15px">
                <a-input v-model.trim="queryParam.clientPhone"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="开票状态" style="margin-left: 45px">
                <a-select v-model="queryParam.invoiceStatus" :allowClear="true">
                  <a-select-option v-for="type in invoice_status" :title="type.dictLabel":key="type.dictValue">{{ type.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="12" :sm="24">
              <a-row :gutter="24"style="margin-left: 0px" >
                <a-form-item label="客户地址"style="margin-left: 45px">
                  <a-col :md="5" :sm="24">
                    <a-select
                      v-model="queryParam.provinceId"
                      @change="getselect"
                      :allowClear="true">
                      <a-select-option v-for="type in selectAllProvince" :title="type.provinceName":key="type.provinceCode">{{ type.provinceName }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select
                      v-model="queryParam.cityId"
                      @change="getprovinceName"
                      :allowClear="true">
                      <a-select-option v-for="type in selectCityName" :title="type.cityName":key="type.cityCode">{{ type.cityName }}</a-select-option>
                    </a-select >
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.areaId" :allowClear="true">
                      <a-select-option v-for="type in selectAreaName" :title="type.areaName":key="type.areaCode">{{ type.areaName }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input v-model.trim="queryParam.clientAddress"/>
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="市场负责人" style="margin-left: 30px">
                <a-select v-model="queryParam.marketPrincipal" :allowClear="true">
                  <a-select-option v-for="type in marketPrincipal" :title="type.userName":key="type.userId">{{ type.userName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号" style="margin-left: 60px">
                <a-input v-model.trim="queryParam.orderNo"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单总计" :labelCol="labelCol" :wrapperCol="wrapperCol"style="margin-left: 45px">
                <a-col :span="11">
                  <a-input placeholder="最小值" v-model.trim="queryParam.orderTotalNumBegin"/>
                </a-col>
                <a-col :span="2" style="display: flex;justify-content: center">
                  -
                </a-col>
                <a-col :span="11">
                  <a-input placeholder="最大值" v-model.trim="queryParam.orderTotalNumEnd"/>
                </a-col>
              </a-form-item>

            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="建单时间" style="margin-left:45px">
                <a-range-picker
                  style="width: 100%"
                  v-model="createOrder"
                  :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChange_e"
                />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="收款时间" style="margin-left: 45px">
                <a-range-picker
                  style="width: 100%"
                  v-model="receiveMoney"
                  :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChange_b" />
              </a-form-item>
            </a-col>
          </a-row>
          <div v-if="Ifstatus">
            <a-row :gutter="24">

              <a-col :md="6" :sm="24">
                <a-form-item label="订单完成时间"style="margin-left: 15px">
                  <a-range-picker
                    v-model="completeOrder"
                    style="width: 100%"
                    :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onChange_f"
                  />
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item label="账单截止日期" style="margin-left: 15px">
                  <a-range-picker
                    v-model="closingDate"
                    style="width: 100%"
                    :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onChange_a" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="生成对账单时间" >
                  <a-range-picker
                    v-model="createStatement"
                    style="width: 100%"
                    :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onChange_d" />
                </a-form-item>
              </a-col>
            </a-row>
          </div>

          <a-row>
            <a-col :span="1" :offset="11">
              <span v-if="Ifstatus == 0" style="cursor:pointer" @click="getMore"><a-icon type="down-circle" theme="twoTone" style="fontSize:24px"/></span>
              <span v-if="Ifstatus == 1" style="cursor:pointer" @click="hiddenMore"><a-icon type="up-circle" theme="twoTone" style="fontSize:24px"/></span>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }">
              <a-button type="primary" htmlType="submit" @click="query">查询</a-button>
              <a-button style="margin-left:8px" @click="empty">清空</a-button>
              <a-button
                style="margin-left: 8px;"
                type="primary"
                v-if="exportStatementsCustomerStatement"
                @click="exportEnt() ">导出 Excel</a-button>
            </a-col>
          </a-row>
          <a-divider/>
          <div class="table-operator">
            <a-row>
              <a-col :span="16"></a-col>

              <a-col :span="8" :style="{ textAlign: 'right' }">
                <!-- 查询功能待完善 只能查询公司名-->
                <a-button
                  type="primary"
                  style="width: 120px;"
                  v-if="batchsettlementCustomerStatement"
                  @click="goBillSettlement()"
                  :disabled="!hasSelected">批量结算</a-button>
                <a-button style="margin-left: 8px;width: 120px;" v-if="removeCustomerStatement":disabled="!hasSelected" @click="batchRemoval()">批量移除对账单</a-button>
              </a-col>
            </a-row>
          </div>
        </a-form>
      </div>
      <!--    表格内容-->
      <a-table
        size="default"
        ref="table"
        rowKey="sourceId"
        :columns="columns"
        :dataSource="this.subList.rows"
        bordered
        :pagination="false"
        :scroll="{ x: 2800}"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :rowClassName="setClassName"
      >
        <span slot="action" slot-scope="text, record" style="white-space: nowrap;">
          <!--生成对账单按钮-->
          <a v-if="viewInnerCustomerStatement" @click="edit(record)">编辑</a>
          <a-divider type="vertical" v-if="viewInnerCustomerStatement"/>
          <!--查看按钮-->

          <a v-if="singlesettlementCustomerStatement&&record.receiveMoneyStatusCode!=2" @click="goSettlement(record)">结算</a>
          <a-divider type="vertical" v-if="singlesettlementCustomerStatement&&record.receiveMoneyStatusCode!=2"/>
          <!--备注按钮-->
          <a v-if="remarkCustomerStatement" @click="remarkList(record)">备注</a>
          <a-divider type="vertical" v-if="remarkCustomerStatement"/>
          <a v-if="record.invoiceStatus==0&&singlesettlementCustomerStatement" @click="Billing(record,0)">开票</a>
          <a-divider type="vertical" v-if="record.invoiceStatus==0&&singlesettlementCustomerStatement" />
          <a v-if="record.invoiceStatus==1&&singlesettlementCustomerStatement" @click="Billing(record,1)">作废</a>
          <a-divider type="vertical" v-if="record.invoiceStatus==1&&singlesettlementCustomerStatement" />
          <a v-if="removeCustomerStatement" @click="remove(record)">移除</a>
          <a-divider type="vertical" v-if="removeCustomerStatement"/>
          <a v-if="record.innerFlag==0&&applyCustomerStatement" @click="reconciliation(record,0)">申请对账</a>
          <a v-if="record.innerFlag==1&&applyCustomerStatement" @click="reconciliation(record,1)">撤回</a>
        </span>
      </a-table>

      <a-pagination
        showQuickJumper="true"
        showSizeChanger
        :pageSizeOptions="pageSizeOptions"
        :pageSize.sync="pageSize"
        @showSizeChange="onShowSizeChange"
        :total="total"
        v-model="current"
        @change="getdataList1"
        :showTotal="total => `总共 ${total} 条`"
        style="text-align: end;margin-top: 20px"
      />
      <!--    最后字段第一行-->
      <a-row v-if="subList.statistics">
        <a-col :span="19" style="margin: 10px 0">
          <a-row>
            <a-col :span="5" >
            </a-col>
            <a-col :span="19" style="text-align: center">
              <span style="font-size: 14px;font-weight: 700">【企业】订单总金额：{{ subList.statistics.enterpriseTotalAmount }}元
                结算总金额：{{ subList.statistics.enterpriseSettleAmount }}元  </span>
              <span style="font-size: 14px;font-weight: 700" v-if="viewMasterPriceCustomerStatement">【师傅】订单总金额：{{ subList.statistics.masterTotalAmount }}元  结算总金额：{{ subList.statistics.masterSettleAmount }}元  </span>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <!--    最后字段第二行-->
      <a-row v-if="subList.statistics">
        <a-col :span="19" style="margin: 10px 0">
          <a-row>
            <a-col :span="5" >
            </a-col>
            <a-col :span="19" style="text-align: center">
              <span style="font-size: 14px;font-weight: 700;text-align: center"><span v-if="viewMasterPriceCustomerStatement">成本：{{ subList.statistics.cost }}元    毛利：{{ subList.statistics.grossProfit }}元</span>     结算扣款：{{ subList.statistics.deduction }}元    已退款金额：{{ subList.statistics.alreadyRefundAmount }}元   订单总计：{{ subList.statistics.orderNum }}单      </span>

            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row v-if="subList.statistics">
        <a-col :span="19" style="margin: 10px 0">
          <a-row>
            <a-col :span="5" >
            </a-col>
            <a-col :span="19" style="text-align: center">
              <span style="font-size: 14px;font-weight: 700;text-align: center">结算金额：{{ subList.statistics.enterpriseSettleAmount }}元       已结算金额：{{ subList.statistics.alreadySettleAmount }}元     实际需结算：{{ subList.statistics.needSettleAmount }}元    已退款金额：{{ subList.statistics.alreadyRefundAmount }}元   订单总计：{{ subList.statistics.orderNum }}单    </span>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <!--    移除的弹框提醒-->
      <!--    移除对账单确定按钮-->
      <a-modal
        title="移除"
        style="top: 20px;"
        :width="800"
        v-model="removeible"
        :confirmLoading="confirmLoading"
        @ok="confirmOk"
        @cancel="confirmCancel"
      >
        <p>确定移除该条对账单吗？</p>
      </a-modal>
      <a-modal
        title="备注"
        style="top: 20px;"
        :width="900"
        :visible="remarkible"
        @ok="remarkconfirmOk"
        @cancel="remarkCancel"
      >
        <a-form :form="form">
          <a-form-item style="display:none">
            <a-input v-decorator="['statementId']"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
            <a-input v-decorator="['remark']"/>
          </a-form-item>
        </a-form>
      </a-modal>
      <!--&lt;!&ndash; 使用弹框组件&ndash;&gt;-->
      <customer-submit-model ref="enterprisesubmit" @query="query"></customer-submit-model>
      <customer-single-model ref="customerSingle" @ok="query" > </customer-single-model>
      <customer-main-settlement-model ref="customermainsettlement" @ok="query"></customer-main-settlement-model>
      <customer-sub-settlement-model ref="customersubsettlement" @ok="query"></customer-sub-settlement-model>
    </a-card>
    <no-authority v-else></no-authority>
  </div>

</template>
<script>
import NoAuthority from '../enterprise/NoAuthority'
import customerSubmitModel from '@/views/finance/modules/customerSubmitModel.vue'
import moment from 'moment'
import customerSingleModel from './modules/customerSingleModel'
import customerMainSettlementModel from './modules/customerMainSettlementModel'
import customerSubSettlementModel from './modules/customerSubSettlementModel'
import
{ getList, getselectAllProvince, getselectCityName, findByDeptId, getselectAreaName, getmarketPrincipal, getSelectBrand, getOrderDetail, getSelectModel, getfindByDeptId, getfinddictAll } from
  '@/api/order/orderList'
import { getselectCombox, getselectSource } from
  '@/api/order/NewlyaddedOrderList'
import { STable } from '@/components'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { saveRemark } from '@/api/finance/enterpriseStatement'
import {
  getSourceList, getmajorSettleList, getSettleList, getEditList, removeSettleList, invoiceCancel, invoice, applyCancel, apply, getexportList } from
  '@/api/finance/customerStatementsList'
import CustomerModal from './modules/CustomerModal.vue'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import pick from 'lodash.pick'
export default {
  name: 'CustomerStatementsList',
  components: {
    STable,
    // 注册弹框组件
    CustomerModal,
    customerSingleModel,
    customerMainSettlementModel,
    customerSubSettlementModel,
    customerSubmitModel,
    NoAuthority
  },
  data () {
    return {

      // 分页
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      total: 0,
      current: 1,
      pageSize: 10,

      statement_status: [],
      selectCombox: [],
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      subList: '',
      // 批量结算包存的id
      statementIds: [],
      // 批量结算相应的数据
      reslist: [],
      // 移除按钮
      removeible: false,
      removeLoading: false,
      // 根据单个id获取到的子对账单的数据
      Settlementlist: [],
      selectedRowKeys: [], // Check here to configure the default column
      selectedRow: [],
      disabled: true,
      loading: false,
      remarkible: false,
      Ifstatus: 0,
      form: this.$form.createForm(this),
      // 查询参数
      queryParam: {},
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center'
        },
        {
          title: '操作栏',

          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }

        },
        {
          title: '账单状态',
          dataIndex: 'statementStatus',
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center'
        },
        {
          title: '账单号',
          dataIndex: 'statementNo',
          align: 'center'
        },
        {
          title: '账单截止日期',
          dataIndex: 'closingDate',
          align: 'center'
        },
        {
          title: '收款状态',
          dataIndex: 'receiveMoneyStatus',
          align: 'center'
        },
        {
          title: '收款时间',
          dataIndex: 'receiveMoneyTime',
          align: 'center'
        },
        {
          title: '订单总计',
          dataIndex: 'orderNum',
          align: 'center'
        },
        {
          title: '安装数量',
          dataIndex: 'installNum',
          align: 'center'
        },
        {
          title: '帐单数',
          dataIndex: 'subStatementNum',
          align: 'center'
        },
        {
          title: '客户自费订单总金额',
          dataIndex: 'customerTotalAmount',
          align: 'center'
        },
        {
          title: '客户自费结算总金额',
          dataIndex: 'customerSettleAmount',
          align: 'center'
        },
        {
          title: '师傅订单总金额',
          className: this.viewMasterPriceCustomerStatement ? '' : 'notshow',
          dataIndex: 'masterTotalAmount',
          align: 'center'
        }, {
          title: '师傅结算总金额',
          className: this.viewMasterPriceCustomerStatement ? '' : 'notshow',
          dataIndex: 'masterSettleAmount',
          align: 'center'
        }, {
          title: '成本',
          dataIndex: 'cost',
          className: this.viewMasterPriceCustomerStatement ? '' : 'notshow',
          align: 'center'
        }, {
          title: '毛利',
          dataIndex: 'grossProfit',
          className: this.viewMasterPriceCustomerStatement ? '' : 'notshow',
          align: 'center'
        }, {
          title: '结算扣款',
          dataIndex: 'deduction',
          align: 'center'
        }, {
          title: '已结算金额',
          dataIndex: 'alreadySettleAmount',
          align: 'center'
        }, {
          title: '实际需结算',
          dataIndex: 'needSettleAmount',
          align: 'center'
        }, {
          title: '已退款金额',
          dataIndex: 'alreadyRefundAmount',
          align: 'center'
        },

        {
          title: '收款超时天数',
          dataIndex: 'overDays',
          align: 'center'
        }, {
          title: '开票状态',
          dataIndex: 'invoiceStatusName',
          align: 'center'
        }, {
          title: '生成对账单时间',
          dataIndex: 'createStatementTime',
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark'

        }
      ],
      data: [],
      // 字典为收款状态
      installTypes: [],
      createOrder: '',
      receiveMoney: '',
      completeOrder: '',
      closingDate: '',
      createStatement: '',

      receive_money_status: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      // 字典为时间类型
      invoice_status: [],
      // 查看师傅金额
      viewMasterPriceCustomerStatement: checkPermission('viewMasterPriceCustomerStatement'),
      // 单个结算
      singlesettlementCustomerStatement: checkPermission('singlesettlementCustomerStatement'),
      // 批量结算
      batchsettlementCustomerStatement: checkPermission('batchsettlementCustomerStatement'),
      // 申请对账/企业对账
      applyCustomerStatement: checkPermission('applyCustomerStatement'),
      // 导出对账单
      exportStatementsCustomerStatement: checkPermission('exportStatementsCustomerStatement'),
      // 备注
      remarkCustomerStatement: checkPermission('remarkCustomerStatement'),
      // 移除
      removeCustomerStatement: checkPermission('removeCustomerStatement'),
      // 查看内部对账单
      viewInnerCustomerStatement: checkPermission('viewInnerCustomerStatement'),
      customerStatementsList: checkPermission('customerStatementsList:query:list')
    }
  },
  filters: {
  },
  // 下拉框的选项
  async created () {
    // 查询市场用户
    await getmarketPrincipal().then(res => {
      this.marketPrincipal = res
    })

    await getselectAllProvince().then(res => {
      if (res.code === 0) {
        // console.log(res)
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
    const dictTypes = ['statement_status', 'invoice_status', 'receive_money_status']
    getfinddictAll({ dictTypes: dictTypes.join() }).then(res => {
      this.invoice_status = res.invoice_status
      this.statement_status = res.statement_status
      this.receive_money_status = res.receive_money_status
    })

    // 企业名称
    this.selectCombox = []
    await getselectCombox().then(res => {
      if (res.code === 0) {
        this.selectCombox = res.data
      } else {
        this.$message.error(res.msg)
      }
    })

    this.getdataList1(1)
  },
  // 计算选中的按钮的显示和隐藏
  computed: {
    hasSelected () {
      return this.selectedRowKeys.length > 0
    }
  },
  methods: {

    // 分页
    onShowSizeChange (current, pageSize) {
      this.pageSize = pageSize
      this.getdataList1(current)
    },

    getdataList1 (value) {
      this.queryParam.pageNum = value
      this.queryParam.pageSize = this.pageSize
      this.handloadData()
    },
    handloadData () {
      getSourceList(this.queryParam).then(res => {
        console.log(res)
        this.subList = res
        this.total = res.total
      })
    },

    SetOptionTitle () {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') { options[j].title = options[j].text }
            }
          }
        }
      }
    },
    empty () {
      // this.queryParam={}

      this.queryParam.enterpriseName = ''
      this.queryParam.statementNo = ''
      this.queryParam.statementStatus = ''
      this.queryParam.receiveMoneyStatus = ''
      this.queryParam.overDays = ''
      this.queryParam.clientName = ''
      this.queryParam.clientPhone = ''
      this.queryParam.invoiceStatus = ''
      this.queryParam.provinceId = ''
      this.queryParam.cityId = ''
      this.queryParam.areaId = ''
      this.queryParam.clientAddress = ''
      this.queryParam.marketPrincipal = ''
      this.queryParam.orderNo = ''
      this.queryParam.orderTotalNumBegin = ''
      this.queryParam.orderTotalNumEnd = ''
      this.queryParam.orderNo = ''

      this.createOrder = ''
      this.receiveMoney = ''
      this.completeOrder = ''
      this.closingDate = ''
      this.createStatement = ''
    },

    moment,
    setClassName (record) {
      // console.log(record)
      if (record.overDays > 0) { // 超时订单
        return 'clickRowStyle'
      }
    },
    exportEnt () {
      var str = process.env.VUE_APP_API_BASE_URL + '/finance/customerStatement/export?pageNum=1&pageSize=10'
      for (const i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
    },
    query () {
      this.selectedRowKeys = []
      this.selectedRows = []
      getSourceList(this.queryParam).then(res => {
        if (res.code === 0) {
          this.subList = res
          this.total = res.total
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    reconciliation (record, type) {
      if (type == 0) {
        apply({ statementLevel: 0, statementId: record.statementId }).then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.getdataList1(this.current)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (type == 1) {
        applyCancel({ statementLevel: 0, statementId: record.statementId }).then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.getdataList1(this.current)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    Billing (record, type) {
      if (type == 0) {
        invoice({ statementId: record.statementId }).then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.getdataList1(this.current)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
      if (type == 1) {
        invoiceCancel({ statementId: record.statementId }).then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.getdataList1(this.current)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    remarkCancel () {
      this.remarkible = false
    },
    remarkconfirmOk () {
      this.remarkible = false
      this.form.validateFields((err, values) => {
        if (!err) {
          saveRemark(values).then(res => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.getdataList1(this.current)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    remarkList (record) {
      this.remarkible = true
      this.form.resetFields()
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(record, 'remark', 'statementId'))
      })
    },

    // 市
    getselect (e) {
      getselectCityName({ provinceCode: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName (e) {
      getselectAreaName({ cityCode: e }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    filterOption (input, option) {
      if (option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        )
      }
    },
    // 编辑按钮
    edit (record) {
      // console.log(record.statementId)
      this.$refs.customerSingle.showcustomerSingle(record.statementId)
    },
    // 批量移除对账单
    batchRemoval () {
      this.statementIds = []
      if (this.selectedRowKeys.length > 0) {
        this.removeible = true
        this.selectedRow.forEach(item => {
          return this.statementIds.push(item.statementId)
        })
      }
    },
    // 移除按钮      // 移除
    remove (record) {
      this.statementIds = []
      this.removeible = true
      this.statementIds.push(record.statementId)
    },
    // 移除确定时调用的方法
    async  confirmOk () {
      this.removeible = false
      this.removeLoading = false
      console.log(this.statementIds)
      await removeSettleList({ statementIds: this.statementIds.join() }).then(res => {
        if (res.code === 0) {
          this.getdataList1(this.current)
        } else {
          this.$message.error(res.msg)
        }
      }
      )
    },
    // 移除取消时调用的方法
    confirmCancel () {
      this.removeible = false
    },
    // 账单截止日期
    onChange_a (date, dateString) {
      this.queryParam.closingDateBegin = dateString[0]
      this.queryParam.closingDateEnd = dateString[1]
    },
    // 收款时间
    onChange_b (date, dateString) {
      this.queryParam.receiveMoneyTimeBegin = dateString[0]
      this.queryParam.receiveMoneyTimeEnd = dateString[1]
    },
    onChange_d (date, dateString) {
      this.queryParam.createStatementTimeBegin = dateString[0]
      this.queryParam.createStatementTimeEnd = dateString[1]
    },
    onChange_e (date, dateString) {
      this.queryParam.createOrderTimeBegin = dateString[0]
      this.queryParam.createOrderTimeEnd = dateString[1]
    },
    onChange_f (date, dateString) {
      this.queryParam.completeOrderTimeBegin = dateString[0]
      this.queryParam.completeOrderTimeEnd = dateString[1]
    },
    handleChangeMin (e) {
      this.queryParam.orderTotalNumBegin = e.target.value
    },
    handleChangeMax (e) {
      this.queryParam.orderTotalNumEnd = e.target.value
    },
    // 更多、隐藏
    getMore () {
      this.Ifstatus = 1
    },
    hiddenMore () {
      this.Ifstatus = 0
    },
    // 结算跳转页面
    goSettlement (record) {
      console.log(record.statementId)
      this.$refs.customersubsettlement.showcustomersubsettlement(record.statementId)
    },
    // 复选框change事件
    onSelectChange (selectedRowKeys, selectedRow) {
      this.selectedRow = selectedRow
      this.selectedRowKeys = selectedRowKeys
      //  console.log(this.selectedRow)
    },
    // 批量结算按钮 跳转
    goBillSettlement () {
      // 有选中的值传id
      this.statementIds = []
      // 有选中的值传id
      if (this.selectedRowKeys.length > 0) {
        this.selectedRow.forEach(item => {
          return this.statementIds.push(item.statementId)
        })
        this.$refs.customermainsettlement.showcustomermainsettlement(this.statementIds)
      } else {
        this.$message.error('至少选择一条数据')
      }
    },
    handleAdd () {
      this.$refs.modal.add()
    },
    ConfirmReceipt (record) {
      this.$refs.modal.confirmReceipt(record)
    },
    confirmRefund () {
      this.$refs.modal.confirmRefund()
    },
    handleremark (record) {
      this.$refs.modal.remark()
    }

  },
  watch: {
  }
}
</script>

<style scoped>
  /deep/ .clickRowStyle {
    background: #ff7575;
  }
  /deep/ .clickRowStyle2 {
    background: #a4ffa1;
  }
  /deep/ .clickRowStyle3 {
    background: #f9ff9f;
  }
  /deep/ .notshow {
    display: none;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}
</style>
